import * as React from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import { useDrawingArea } from "@mui/x-charts/hooks";
import { styled } from "@mui/material/styles";
import { Card, CardContent, CardHeader } from "@mui/material";

const size = {
  // width: 500,
  height: 250,
};

const StyledText = styled("text")(({ theme }) => ({
  fill: theme.palette.text.primary,
  textAnchor: "middle",
  dominantBaseline: "central",
  fontSize: 14,
}));

function PieCenterLabel({ children }) {
  const { width, height, left, top } = useDrawingArea();
  return (
    <StyledText x={left + width / 2} y={top + height / 2}>
      {children}
    </StyledText>
  );
}

export default function StatusPieChart(props) {
  const { data } = props;

  const TOTAL = data.map((item) => item.value).reduce((a, b) => a + b, 0);

  return (
    <Card >
      <CardHeader title="IRB Status Analytics" />
      <CardContent>
      <PieChart
          series={[
            {
              data,
              innerRadius: 80,
            },
          ]}
          // slotProps={{ legend: { hidden: isMobile ? true : false } }}
          {...size}
        >
          <PieCenterLabel>Total Submitted: {TOTAL}</PieCenterLabel>
        </PieChart> 
      </CardContent>
    </Card>
  );
}
